// Returns HTML string for car approval email to admin
export function getCarApprovalEmailTemplate({ id, userName, date }) {
  return `
    <h2>Car Approval Needed</h2>
    <p>
      Dear Admin,<br><br>
      A new car listing requires your approval.<br><br>
      <b>Car ID:</b> ${id}<br>
      <b>User:</b> ${userName}<br>
      <b>Date Submitted:</b> ${date}<br><br>
      Please review and approve the car listing at your earliest convenience.<br><br>
      Thank you,<br>
      MotoStream Team
    </p>
  `;
}
